import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { t } from '../../helpers/translate.js';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { Box } from '../Box/Box.js';
import { Card } from '../Card/Card.js';
import { CardHeader } from '../CardHeader/CardHeader.js';
import { Link } from '../Link/Link.js';
import { StepLabel } from '../Stepper/StepLabel.js';
import { useSteppedForm } from './SteppedFormProvider.js';

const StyledCard = styled(Card).withConfig({
  componentId: "sc-pcupb5-0"
})(["position:relative;", ""], ({
  showStepLine,
  theme
}) => showStepLine && css(["&::after{content:'';position:absolute;left:34px;top:calc(100% + 8px);height:8px;width:2px;background-color:", ";}"], theme.components.steppedForm.stepLineBackgroundColor));
const SteppedFormStep = /*#__PURE__*/withTitan(({
  title,
  stepIndex = 0,
  children,
  onSubmit,
  formWrapper,
  testId = 'steppedFormStep'
}) => {
  const {
    activeStepIndex,
    goToStep,
    nextStep,
    previousStep,
    formId,
    buttonEdit,
    totalSteps
  } = useSteppedForm();
  const isActiveStep = stepIndex === activeStepIndex;
  const stepContent = jsx("form", {
    id: formId,
    onSubmit: e => onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(e, {
      nextStep,
      previousStep
    }),
    children: children
  });
  return jsxs(Fragment, {
    children: [jsx(StyledCard, {
      backgroundVariant: isActiveStep ? 'grey' : 'white',
      isBordered: !isActiveStep,
      showDivider: false,
      showStepLine: stepIndex !== activeStepIndex && stepIndex !== totalSteps - 1,
      spaceAfter: isActiveStep ? 0 : 6,
      testId: `${testId}Card`,
      children: jsx(CardHeader, {
        actions: activeStepIndex > stepIndex && jsx(Link, {
          onClick: () => goToStep(stepIndex),
          children: t((buttonEdit === null || buttonEdit === void 0 ? void 0 : buttonEdit.label) || 'Wijzig')
        }),
        children: jsx(StepLabel, {
          isActive: isActiveStep,
          isCompleted: activeStepIndex > stepIndex,
          isDisabled: activeStepIndex < stepIndex,
          label: title,
          step: stepIndex + 1
        })
      })
    }, stepIndex), isActiveStep && jsx(Box, {
      "data-test-id": `${testId}Content`,
      pb: {
        xs: 6,
        s: 10
      },
      pt: {
        xs: 4,
        s: 6
      },
      px: {
        xs: 0,
        s: 6
      },
      children: formWrapper ? formWrapper(stepContent) : stepContent
    })]
  });
}, {
  name: 'SteppedFormStep'
});

export { SteppedFormStep };
//# sourceMappingURL=SteppedFormStep.js.map
